module.exports = __webpack_public_path__ + "static/media/modal_sign_title.1f50f78b.png";